import { MeterRateTaskType, MeterTaskResultType } from '../../../../../../redux/jobs/jobs.types';
import { sortMeterRates } from '../../../../../../helper/Sorting';

export interface SubmittedReadingSnapshot {
    readingDate: string;
    results: Array<MeterTaskResultType>;
}

export interface SubmittedReadingRow {
    taskId: string;
    obis?: string;
    rateName?: string;
    unit?: string;
    preDecimals?: number;
    postDecimals?: number;
    readingValueValidation?: MeterRateTaskType['readingValueValidation'];
    readingDate: string;
    readingValue: number;
    comment?: string;
}

export const buildSubmittedReadingRows = ({
    meterRateTasks,
    submittedReading,
}: {
    meterRateTasks: Array<MeterRateTaskType>;
    submittedReading?: SubmittedReadingSnapshot;
}): Array<SubmittedReadingRow> => {
    if (!submittedReading) {
        return sortMeterRates(meterRateTasks).flatMap((task) => {
            const latestReadingResult = task.readingResults?.slice(-1)[0];

            if (!latestReadingResult) {
                return [];
            }

            return [
                {
                    ...task,
                    readingDate: latestReadingResult.readingDate,
                    readingValue: latestReadingResult.readingValue,
                    comment: latestReadingResult.comment,
                },
            ];
        });
    }

    const resultByTaskId = submittedReading.results.reduce<Record<string, MeterTaskResultType>>((res, result) => {
        res[result.taskId] = result;
        return res;
    }, {});

    return sortMeterRates(meterRateTasks).flatMap((task) => {
        const submittedResult = resultByTaskId[task.taskId];

        if (!submittedResult) {
            return [];
        }

        return [
            {
                ...task,
                readingDate: submittedReading.readingDate,
                readingValue: submittedResult.readingValue,
                comment: submittedResult.comment,
            },
        ];
    });
};
